<template>
  <div id="myProject">
    <div class="contain">
      <div class="box" @click="toPrjClick(item)" v-for="(item, index) in boxList" :key="index">
        <div class="boxImg" >
          <elegantImg :prjId="item.prjId" :prjName="item.prjName"/>
        </div>
        <div class="boxBottom">
          <p class="boxTitle">
            <span :title="item.prjName">{{ item.prjName }}</span>
          </p>
          <div class="boxBuName">
            <div :title="item.provinceCity" class="title"><span>地区：</span>{{ item.provinceCity }}</div>
            
            <!-- <div class="title" :title="item.prjCategory"><span> 项目业态：</span>{{ item.prjCategory }}</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/xgzdService/project-service.js'
import { mapState } from 'vuex'
import elegantImg from './elegant-img.vue'
import limiterState from './limiter-state'
export default {
  components: {elegantImg},
  name: 'myProject',
  data() {
    return {
      boxList: [],
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
    }
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  beforeDestroy() {
    // 清空并发控制的图片请求
    limiterState && limiterState.clear()
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const { enterpriseId } = this
      const { data } = await request.getPrjsByUserId(enterpriseId)
      this.boxList = data
    },
    toPrjClick(item) {
      this.$store.dispatch('updatePrj', item)
      sessionStorage.setItem('prePrj', JSON.stringify(item.prjId))
      this.$router.push({ name: 'project' })
    },
    //更多按钮
    moreClick() {
      this.$emit("jumpMyProject")
    }
  }
}
</script>

<style scoped lang="scss">
#myProject {
  height: 100%;
  width: 100%;
  background: #fff;
  overflow: hidden;
  border-radius: 3px;
  .contain {
    height: 100%;
    padding:11px 23px ;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: max-content;
    grid-gap: 20px;
  }
  .box:hover {
    box-shadow: 0px 0px 4px 2px rgba(159, 158, 156, 0.13);
    border: 1px solid #87B0FF;
  }
  .box {
    overflow: hidden;
    margin-bottom: 14px;
    border-radius: 3px;
    overflow: hidden;
    border: 1px solid #e9effb;
    padding: 10px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-around;
    position: relative;
    gap: 2px;
    > * {
      position: relative;
    }
  }
  .boxImg {
    min-height: 100px;
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 3px;
    img {
      width: 100%;
      height: 100%;
      border: 0;
      object-fit: cover;
      border-radius: 3px;
    }
  }
  .boxBottom {
    height: 25%;
    flex-shrink: 0;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    .boxTitle {
      line-height: 20px;
      text-align: left;
      span {
        font-size: 16px;
        width: calc(100% - 55px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
      }
    }
    .boxBuName {
      line-height: 20px;
      font-size: 13px;
      color: #666666;
      text-align: left;
      display: flex;
      align-items: center;
      span{
        color: #ADADAD;
      }
      .title:first-child{
        width: 55%;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
        margin-right:10px
      }
       .title:last-child{
        width: 35%;
        margin-left:10px;
        white-space: nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
      }
    }
  }
}
</style>
